import createIcon from '../../createIcon';

/**
 * @component @name BurstMode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSA1SDNWMTlIMVY1Wk01IDVIN1YxOUg1VjVaTTIyIDVIMTBDOS40NSA1IDkgNS40NSA5IDZWMThDOSAxOC41NSA5LjQ1IDE5IDEwIDE5SDIyQzIyLjU1IDE5IDIzIDE4LjU1IDIzIDE4VjZDMjMgNS40NSAyMi41NSA1IDIyIDVaTTExIDE3TDEzLjUgMTMuODVMMTUuMjkgMTZMMTcuNzkgMTIuNzhMMjEgMTdIMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BurstMode = createIcon('BurstMode', [
  [
    'path',
    {
      d: 'M1 5H3V19H1V5ZM5 5H7V19H5V5ZM22 5H10C9.45 5 9 5.45 9 6V18C9 18.55 9.45 19 10 19H22C22.55 19 23 18.55 23 18V6C23 5.45 22.55 5 22 5ZM11 17L13.5 13.85L15.29 16L17.79 12.78L21 17H11Z',
      key: '11490o',
    },
  ],
]);

export default BurstMode;
